/**
 * 将任意入参规范为可上报的字符串
 * @param {unknown} content
 * @returns {string}
 */
function normalizeLogContent(content) {
  if (content == null) return ''
  if (typeof content === 'string') return content
  if (typeof content === 'number' || typeof content === 'boolean' || typeof content === 'bigint') {
    return String(content)
  }
  if (content instanceof Error) {
    const stack = content.stack ? String(content.stack).slice(0, 400) : ''
    return `${content.message || content.name || 'Error'}${stack ? ' | ' + stack : ''}`
  }
  // prettier-ignore
  try {
    return JSON.stringify(content)
  }
  catch (_) {
    return String(content)
  }
}

/**
 * 通过客户端注入的 log 通道上报日志（iOS webkit / Android globalThis.log）
 * @param {string|object|unknown} content 日志正文，支持字符串或对象
 */
export function $postClientLog(content) {
  // prettier-ignore
  try {
    const payload = JSON.stringify({ content: normalizeLogContent(content) })

    console.log('$postClientLog:', payload)

    const iosHandler = window.webkit?.messageHandlers?.log
    if (iosHandler?.postMessage) {
      iosHandler.postMessage(payload)
      return
    }

    const androidBridge = globalThis.log
    if (typeof androidBridge?.postMessage === 'function') {
      androidBridge.postMessage(payload)
    }
  }
  catch (err) {
    console.log('try catch err: $postClientLog', err)
  }
}

/**
 * 格式化错误并上报到客户端 log 通道
 * @param {string} tag 场景标识
 * @param {unknown} err 错误对象
 */
export function $postClientErr(tag, err) {
  // prettier-ignore
  try {
    const msg = err && err.message ? err.message : String(err)
    const stack = err && err.stack ? String(err.stack).slice(0, 400) : ''
    const text = `[Err] ${tag}: ${msg}${stack ? ' | ' + stack : ''}`
    $postClientLog(text)
  }
  catch (_) {
    console.log('try catch err: $postClientErr', err)
  }
}

if (typeof window !== 'undefined') {
  window.$postClientLog = $postClientLog
  window.$postClientErr = $postClientErr
}
